import React from 'react';

import {
  useArchivedJobProspectsState,
  useArchivedJobProspectsActions
} from './ArchivedJobProspectsContext';

import {
  getArchivedJobProspects,
} from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const ArchivedJobProspectsPageController = () => {
  const archivedJobProspectsState = useArchivedJobProspectsState();
  const { onResponse, onError } = useArchivedJobProspectsActions();

  return (
    <PageController
      pageNumber={archivedJobProspectsState?.pageNumber}
      numberOfPages={archivedJobProspectsState?.numberOfPages}
      goToFirstPage={() => {
        getArchivedJobProspects({
          onResponse,
          onError,
          body: {
            pageNumber: 1,
          },
        });
      }}
      goToPreviousPage={() => {
        getArchivedJobProspects({
          onResponse,
          onError,
          body: {
            pageNumber: (archivedJobProspectsState?.pageNumber - 1),
          },
        });
      }}
      goToNextPage={() => {
        getArchivedJobProspects({
          onResponse,
          onError,
          body: {
            pageNumber: (archivedJobProspectsState?.pageNumber + 1),
          },
        });
      }}
      goToLastPage={() => {
        getArchivedJobProspects({
          onResponse,
          onError,
          body: {
            pageNumber: archivedJobProspectsState?.numberOfPages,
          },
        });
      }}
    />
  );
};

export default ArchivedJobProspectsPageController;
